import {resource} from '@albert-io/json-api-framework/request/builder';

export function getAssignmentQuery({assignmentId, studentId}) {
  return resource('assignment_v3')
    .mandarkEndpoint(['assignments_v3', assignmentId])
    .customQuery(
      {
        meta: {
          context: {
            student: {
              id: studentId
            },
            user: {
              id: studentId
            }
          }
        }
      },
      studentId
    )
    .include('classrooms_v1')
    .include('students_v2', studentId)
    .include('teacher_v1')
    .include('student_classrooms_v1')
    .include('question_sets_v1')
    .include('guesses_v1.question_v3')
    .filter({
      included: {
        students_v2: {
          id: studentId
        },
        student_classrooms_v1: {
          students_v2: {
            id: studentId
          }
        },
        classrooms_v1: {
          students_v2: {
            id: studentId
          }
        },
        guesses_v1: {
          question_v3: {
            id: {
              null: false
            }
          },
          student_v2: {
            id: studentId
          }
        }
      }
    })
    .withMeta('assignment_v3');
}

export function getAssignmentQuestionSetsQuery({assignmentId, studentId, randomize = false}) {
  return resource('question_sets_v1')
    .mandarkEndpoint(['assignments_v3', assignmentId, 'question_sets_v1'])
    .sort('meta.assignment_position', !randomize)
    .include('subject_v2')
    .include('questions_v3.question_set_v1.tags_v1')
    .include('questions_v3.standards_v1.standard_set_v1')
    .include('guide_levels_v2.guide_v1')
    .fields({
      guide_v1: 'guide_type'
    })
    .withMeta('subject_v2,question_set_v1,question_v3')
    .customQuery({
      meta: {
        context: {
          student: {
            id: studentId
          },
          user: {
            id: studentId
          },
          assignment: {
            id: assignmentId
          }
        }
      }
    })
    .customQuery(
      {
        random_seed: `0.${parseInt(assignmentId.substr(0, 4) + studentId.substr(0, 4), 16)}`
      },
      randomize
    );
}
